import React, { useEffect, useState } from "react";
import closeIcon from "../../../../assets/icons/close.svg";
import { Modal } from "antd";
import "./addContent.scss";
import SelectContent from "./SelectContent";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import SubmitContent from "./SubmitContent";
import ContentLibraryService from "../../../../services/ContentLibraryService/contentLibrary.service";
import ChapterContentService from "../../../../services/CourseServices/ChapterService/chapterContent.service";
import { RouteComponentProps, withRouter } from "react-router";
import { ExamContentService } from "../../../../services/ExamService/ContentService/content.service";
interface AddContentProps extends RouteComponentProps {
	visible: any,
	setVisible: Function,
	refreshList: Function,
	activeChapter: any,
}


const AddContent = (props: AddContentProps) => {
	const { visible, setVisible, refreshList, activeChapter } = props;

	useEffect(() => {
		fetchContentList();
			setUrlParams(props.match.params)
	}, []);

	const fetchContentList = (searchString?: string) => {
		let queryParam = `?search=${searchString || ""}`;

		ContentLibraryService.getContentLibraryList(
			queryParam,
			(contentLibrary: any) => {
				setContents(contentLibrary);
			},
			() => {},
			() => {}
		).then();
	};

	const handleSearch = (value: string) => {
		fetchContentList(value);
	};

	const [contents, setContents] = useState<any>([]);
	const [selectedContents, setSelectedContents] = useState<any>([]);
	const [buttonLoading, setButtonLoading] = useState<boolean>(false);
	const [action, setAction] = useState<string>("select");
	const [urlParams, setUrlParams] = useState<any>()
	const handleButtonClick = () => {
		if (action === "select") {
			setAction("submit");
		} else if (action === "submit") {
			setButtonLoading(true);
			if (props.location.pathname.includes("exams") && urlParams?.subjectId) {			
				const chapterContents = selectedContents.map(
					(selectedContent: any) => ({
						title: selectedContent.displayTitle,
						description: selectedContent.description,
						examChapterId: activeChapter.id,
						contentLibraryId: selectedContent.id,
						isActive: selectedContent.isActive
							? selectedContent.isActive
							: false,
					})
				);
					

				ExamContentService.createNewExamContent(
					chapterContents,
					() => {
						refreshList();
						setAction("select");
						setSelectedContents([]);
						setVisible(false);
						setButtonLoading(false);
					},
					() => {
						setButtonLoading(false);
					}
				)
	
					

			} else {
				const chapterContents = selectedContents.map(
					(selectedContent: any) => ({
						title: selectedContent.displayTitle,
						description: selectedContent.description,
						chaptor_id: activeChapter.id,
						content_library_id: selectedContent.id,
						is_active: selectedContent.isActive
							? selectedContent.isActive
							: false,
					})
				);
	
				const data = { chaptor_contents: chapterContents };
	
				ChapterContentService.addChapterContents(
					data,
					() => {
						refreshList();
						setAction("select");
						setSelectedContents([]);
						setVisible(false);
						
					},
					() => {},
					() => {
						setButtonLoading(false);
					}
				).then();
			}
		}
	};

	return (
		<Modal
			title={null}
			centered
			visible={visible}
			onCancel={() => setVisible(false)}
			footer={null}
			className="board-form__modal add-content__modal"
			closeIcon={<img src={closeIcon} alt="" />}
		>
			<div className="board-form__title add-content-modal__title">
				Add new content
			</div>
			{action === "select" && (
				<SelectContent
					handleSearch={handleSearch}
					contentList={contents}
					setSelectedContents={setSelectedContents}
					selectedContents={selectedContents}
				/>
			)}
			{action === "submit" && (
				<SubmitContent
					setSelectedContents={setSelectedContents}
					selectedContents={selectedContents}
					contentList={contents}
					setContentsList={setContents}
				/>
			)}
			<div className="board-form__action">
				<div
					className="board-form__button"
					onClick={() => {
						setVisible(false);
						setSelectedContents([]);
						setAction("select");
					}}
				>
					<ButtonComponent buttonContent="Cancel" type="text" />
				</div>
				<div className="board-form__button">
					<ButtonComponent
						buttonContent={action === "select" ? "Next" : "Submit"}
						type="primary"
						htmlType="submit"
						loading={buttonLoading}
						onClick={handleButtonClick}
						disabled={
							action === "submit" &&
							!selectedContents.every(
								(selectedContent: any) =>
									!!selectedContent.displayTitle
							)
						}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default withRouter(AddContent);
